import { useState, useEffect } from "react";
import { accountAPI, reminderAPI, transactionAPI } from "services";
import { ExpandableButton, Loader } from "components";
import ReminderAlert from "views/Khata/Reminder/ReminderAlert";
import { NewTxn, EditTxn } from "forms";
import useUniversalStore from "store/universalStore";
import Header from "./Header";
import Footer from "./Footer";
import TxnsListView from "./TxnsListView";
// import RecursivetxnsView from "forms/Recursive/RecursivetxnsView";

const Khata = () => {
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [reminder, setReminder] = useState(null);
  const [hideCancelled, setHideCancelled] = useState(true);
  const { accountId, write, accounts, isSharedAccount } = useUniversalStore((state) => state);
  const account = accounts.find((acc) => acc.id === accountId);

  //TODO : needs to be moved to relevant component
  const [animation, setAnimation] = useState("");

  //const goToNextStep = useOnboardingStore((state) => state.goToNextStep);

  // Filter reminder for current account from global store
  useEffect(() => {
    const reminderData = account?.get("reminder");
    setReminder(reminderData || null);
    checkOverdueReminder(reminderData);
  }, [account]);

  //method to check the overdue reminder
  const checkOverdueReminder = (reminder) => {
    if (reminder) {
      const reminderScheduleTime = reminder?.date;
      const reminderEnable = reminder?.enabled;
      const paymentOverdue = reminderScheduleTime && new Date(reminderScheduleTime).getTime() < Date.now();
      setOverlayVisible(paymentOverdue && reminderEnable);
    } else {
      setOverlayVisible(false);
    }
  };

  const editTxn = (data) => write({ transactionId: data.id });

  /*  const confirmit = (txn) => {
    write((prev) => {
      let tempVar = { ...prev.deleteTransactions };
      tempVar.type = "Transaction";
      tempVar.object = txn;
      return { ...prev, deleteTransactions: tempVar };
    });
    const toDel = { delTxn: txn };
    
    // setDeletionOf(txn);
  };*/

  const handleNewDate = (newDate) => {
    // setMonth(newDate);
    write({ selectedMonth: newDate });
  };

  const handleToggle = (value) => {
    setHideCancelled(value);
  }

  const closeReminderAlert = async () => {
    const res = await reminderAPI.toggleReminder(account.id, false);
    setOverlayVisible(false);
    write({ accounts: res })
  }

  if (!account) return <Loader />;


  return (
    <>
      <div className="position-relative">
        {/* Overlay for background blur and disabling interaction */}
        {isOverlayVisible && !isSharedAccount && (
          <div className="overlay d-flex justify-content-center align-items-center">
            <ReminderAlert
              account={account}
              closeReminderAlert={closeReminderAlert} />
          </div>
        )}
        <div className={`content-container d-flex flex-column background vh-100 ${isOverlayVisible ? "disabled" : ""}`}>
          <Header
            handleNewDate={handleNewDate}
            account={account}
            setAnimation={setAnimation}
            hideCancelled={hideCancelled}
            handleToggle={handleToggle}
            goBack={() => write({ accountId: null })}
          />

          <TxnsListView
            hideClosed={hideCancelled}
            handleToggle={handleToggle}
            editTxn={editTxn}
            animation={animation}
            setAnimation={setAnimation}
          />
          {/* Only shows button when a valid user exists */}
          {!isSharedAccount && <div
            className="addTxn-btn"
          >
            <ExpandableButton
              title="New Entry"
              formId="newTxn"
              icon="bi bi-pencil-fill"
            />
          </div>}

          <Footer account={account} />

          {/* <RecursivetxnsView account={account} /> */}
          {/* <EditRTxn /> */}
        </div>
      </div>
    </>
  );
};

export default Khata;